import { Component } from '@angular/core';

@Component({
  selector: 'app-post-execution',
  templateUrl: './post-execution.component.html',
  styleUrl: './post-execution.component.scss'
})
export class PostExecutionComponent {

}
